/**
 * Registry for track class references used in track type conversion.
 * This breaks the circular dependency between VariantTrack and CNVPytorTrack.
 */
const trackClasses = {}

export default trackClasses

